'use client'

/* eslint-disable no-console */
/* eslint-disable react/no-danger */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React from 'react'
import Image from 'next/image'
import WidgetModal from '@components/WidgetModal/WidgetModal'
import {
  getAutoWidgetLayout,
  getHealthWidgetLayout,
  getCtaWidgetPurpleLayout,
  ContainerVisibility,
  shouldDisplayWidget,
} from '@configs/productWidget.config'
import { getClassNames, getWidgetLayoutConfig, getHeroImageSize } from '@helpers/productWidgetHelper'
import styles from './productWidget.module.scss'
import ProductWidgetNewLayout from './productWidgetNewLayout'
import ProductWidgetHeader from './subComponents/productWidgetHeader'
import ProductLobWidget from './subComponents/productLobWidget'
import ProductKeyFeaturesAndCta from './subComponents/productKeyFeaturesAndCta'

const ProductWidget = ({
  isMobileDevice,
  data,
  segmentEventCommonProperties,
  reqCookie,
  isSemPage,
  productWidgetData,
  lob,
  combinedStyles,
  regexPatternsData,
}) => {
  const content = data?.data?.attributes

  const { isAutoWidgetLayout, isSeoCarWidget, isOldLayout, isHealthWidgetPurpleLayout, isCtaPurpleLayout } =
    getWidgetLayoutConfig(content, lob, isSemPage, getAutoWidgetLayout, getHealthWidgetLayout, getCtaWidgetPurpleLayout)

  const THEME_CONFIG = {
    light: styles.lightTheme,
    dark: '',
  }

  if (!isOldLayout) {
    return (
      <ProductWidgetNewLayout
        isMobileDevice={isMobileDevice}
        data={data}
        segmentEventCommonProperties={segmentEventCommonProperties}
        reqCookie={reqCookie}
        isSemPage={isSemPage}
        productWidgetData={productWidgetData}
        combinedStyles={combinedStyles}
        regexPatternsData={regexPatternsData}
      />
    )
  }

  // Combining base and conditional classes
  const containerClassNames = getClassNames([styles.productWidgetMainContainer, styles.mainContainerSemLayout], {
    [styles.semPageHeader]: isSemPage && !isAutoWidgetLayout && !isHealthWidgetPurpleLayout,
    [styles.seoPurpleVariant]: isSeoCarWidget,
    [styles.AbhalayoutWidthChange]: isHealthWidgetPurpleLayout,
    [styles.ctaPurpleLayoutStyles]: isCtaPurpleLayout,
  })

  const heroImageContainerClassNames = getClassNames([styles.semHeroImageWeb], {
    [styles.seoDontRenderContent]: isHealthWidgetPurpleLayout,
  })

  const titleAndFeaturesContainerClassNames = getClassNames([styles.titleAndKeyFeatures], {
    [styles.ctaPurpleSectionMargin]: isCtaPurpleLayout,
  })

  return (
    <div id="productWidget" className={containerClassNames}>
      <div className={titleAndFeaturesContainerClassNames}>
        <ProductWidgetHeader
          content={content}
          isSeoCarWidget={isSeoCarWidget}
          THEME_CONFIG={THEME_CONFIG}
          isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
        />
        {shouldDisplayWidget(content?.widget, ContainerVisibility.HIDE) && (
          <ProductLobWidget
            content={content}
            isMobileDevice={isMobileDevice}
            segmentEventCommonProperties={segmentEventCommonProperties}
            reqCookie={reqCookie}
            isSemPage={isSemPage}
            isOldLayout={isOldLayout}
            combinedStyles={combinedStyles}
            regexPatternsData={regexPatternsData}
            isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
            widgetOptions={content?.widgetOptions}
          />
        )}
        <ProductKeyFeaturesAndCta
          content={content}
          isMobileView={false}
          isAutoWidgetLayout={isAutoWidgetLayout}
          isSeoCarWidget={isSeoCarWidget}
          THEME_CONFIG={THEME_CONFIG}
          segmentEventCommonProperties={segmentEventCommonProperties}
          renderCtaButton
          isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
          getCtaWidgetPurpleLayout={isCtaPurpleLayout}
        />
      </div>

      {shouldDisplayWidget(content?.widget, ContainerVisibility.SHOW) && (
        <ProductLobWidget
          content={content}
          isMobileDevice={isMobileDevice}
          segmentEventCommonProperties={segmentEventCommonProperties}
          reqCookie={reqCookie}
          isSemPage={isSemPage}
          isOldLayout={isOldLayout}
          combinedStyles={combinedStyles}
          regexPatternsData={regexPatternsData}
          isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
          widgetVisibleAlways={isHealthWidgetPurpleLayout}
          widgetOptions={content?.widgetOptions}
        />
      )}

      <ProductKeyFeaturesAndCta
        content={content}
        isMobileView
        isAutoWidgetLayout={isAutoWidgetLayout}
        isSeoCarWidget={isSeoCarWidget}
        THEME_CONFIG={THEME_CONFIG}
        segmentEventCommonProperties={segmentEventCommonProperties}
        renderCtaButton={false}
        isHealthWidgetPurpleLayout={isHealthWidgetPurpleLayout}
        hideSection
        getCtaWidgetPurpleLayout={isCtaPurpleLayout}
      />

      <Image
        src={content?.productWidgetHeroImageDesktop?.data?.attributes?.url}
        alt="Hero image desktop"
        width={getHeroImageSize(isSeoCarWidget, isCtaPurpleLayout)}
        height={getHeroImageSize(isSeoCarWidget, isCtaPurpleLayout)}
        className={heroImageContainerClassNames}
        priority
      />

      <WidgetModal
        content={content}
        bottomFloaterWidgetCta={content?.widget}
        segmentEventCommonProperties={segmentEventCommonProperties}
        reqCookie={reqCookie}
        isSemPage={isSemPage}
        productWidgetData={productWidgetData}
        regexPatternsData={regexPatternsData}
      />
    </div>
  )
}

export default ProductWidget
